import { ManageMultipleDeclarationsStore } from "../ManageMultipleDeclarations";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Popover,
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import InfoIcon from "@mui/icons-material/Info";
import { DeclarationsService } from "../../../../../services/api/declarationsService";
import advService from "../../../../../util/advService";
import { POST_EXCEL_FILE_MAPPING } from "../../../../../util/newconfig";

const defaultMapName = {
    declarationDate: "Declaration Date",
    goodsValue: "Goods Value",
    remark: "Remark",
    receiverName: "Receiver Name",
    receiverAddress: "Receiver Address",
    consignmentDetails: "Consignment Details",
    senderName: "Sender Name",
    invoiceNumber: "Invoice Number",
    invoiceDate: "Invoice Date",
    transportationMode: "Transportation Mode",
    transportationNumber: "Transportation Number",
};

type Props = {
    store: ManageMultipleDeclarationsStore;
    setStore: React.Dispatch<
        React.SetStateAction<ManageMultipleDeclarationsStore>
    >;
};

// create a yup schema for the data
const schema = Yup.object().shape({
    declarationDate: Yup.string()
        .required("Declaration date is required")
        .test(
            "is-valid-date",
            "Invalid date format in declaration date",
            (value) => {
                if (value === "Invalid Date") {
                    return false;
                }
                return dayjs(value, "YYYY-MM-DD", true).isValid();
            }
        ),
    goodsValue: Yup.number().required("Goods value is required"),
    remark: Yup.string().required("Remark is required"),
    receiverName: Yup.string(),
    receiverAddress: Yup.string(),
    consignmentDetails: Yup.string(),
    senderName: Yup.string(),
    invoiceNumber: Yup.string(),
    invoiceDate: Yup.string().test(
        "is-valid-date",
        "Invalid date format in invoice date",
        (value) => {
            if (value === "Invalid Date") {
                return false;
            }
            if(value) {
                return dayjs(value, "YYYY-MM-DD", true).isValid();
            }
            return true;
        }
    ),
    transportationMode: Yup.string(),
    transportationNumber: Yup.string(),
});

const ManageMultipleDeclarationsStep3 = (props: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [correctData, setCorrectData] = useState<Record<string, string>[]>(
        []
    );
    const [errorData, setErrorData] = useState<Record<string, string>[]>([]);
    const [hoveredRow, setHoveredRow] = useState<number | null>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    useEffect(() => {
        // Validate the mapped data using the schema and store error and correct data also store error key in the errorData
        const validateData = async () => {
            const validData: Record<string, string>[] = [];
            const invalidData: Record<string, string>[] = [];
            debugger;
            setIsLoading(true);
            for (const declaration of props.store.mappedData) {
                try {
                    await schema.validate(declaration);
                    validData.push(declaration);
                } catch (error) {
                    invalidData.push({
                        ...declaration,
                        error: (error as Yup.ValidationError).errors.join(", "),
                    });
                }
            }

            setCorrectData(validData);
            setErrorData(invalidData);
            setIsLoading(false);
        };
        validateData();
    }, [props.store.mappedData]);

    if (isLoading) {
        return <div>Loading...</div>;
    }
    return (
        <Box
            sx={{
                width: "60vw",
            }}
            >
            <TableContainer component={Paper} className="mt-4">
                <Table aria-label="declaration review table">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                            <TableCell></TableCell>
                            {Object.keys(
                                props.store.selectedMappingMapping
                            ).map((mapping, index) => (
                                <TableCell key={index}>
                                    <Box
                                        sx={{
                                            // stop the text from wrapping
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {/* @ts-ignore */}
                                        {defaultMapName?.[mapping] || "undefined"}
                                    </Box>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            // show incorrect data first and then correct data
                            // in errorData show the error in info icon
                            errorData.map((declaration, index) => (

                                
                                <TableRow key={index} className="error-row">
                                    
                                    <TableCell
                                        onMouseEnter={(event) => {
                                            setHoveredRow(index);
                                            // @ts-ignore
                                            setAnchorEl(event.currentTarget);
                                        }}
                                        onMouseLeave={() => {
                                            setHoveredRow(null);
                                            setAnchorEl(null);
                                        }}
                                        sx={{
                                            backgroundColor: "#f8d7da",
                                            color: "#721c24",
                                        }}
                                    >
                                        <InfoIcon className="error-icon" />
                                        <Popover
                                            open={hoveredRow === index}
                                            anchorEl={anchorEl}
                                            onClose={() => {
                                                setHoveredRow(null);
                                                setAnchorEl(null);
                                            }}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "center",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "center",
                                            }}
                                            sx={{
                                                pointerEvents: "none",
                                                maxWidth: "400px",
                                            }}
                                        >
                                            <Box sx={{ p: 1 }}>
                                                {declaration.error}
                                            </Box>
                                        </Popover>
                                    </TableCell>
                                    {Object.keys(props.store.selectedMappingMapping).map(
                                        (key, index) =>
                                            key !== "error" && (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        py: "0px",
                                                        backgroundColor:
                                                            "#f8d7da",
                                                        color: "#721c24",
                                                        height: "20px",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            // stop the text from wrapping
                                                            whiteSpace:
                                                                "nowrap",
                                                            height: "20px",
                                                            overflow: "hidden",
                                                            textOverflow:
                                                                "ellipsis",

                                                            "&:hover": {
                                                                overflowX:
                                                                    "scroll",
                                                                height: "30px",
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                            },
                                                        }}
                                                    >
                                                        {declaration[key]}
                                                    </Box>
                                                </TableCell>
                                            )
                                    )}
                                </TableRow>
                            ))
                        }
                        {correctData.map((declaration, index) => (
                            <TableRow key={index}>
                                <TableCell></TableCell>
                                {Object.keys(props.store.selectedMappingMapping).map((key, index) => (
                                    <TableCell key={index}
                                        sx={{
                                            py: "0px",
                                            height: "20px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            "&:hover": {
                                                overflowX: "scroll",
                                                height: "30px",
                                                display: "flex",
                                                alignItems: "center",
                                            },
                                        }}
                                    >
                                        {declaration[key]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className="buttons">
                <button
                    className="btn simple"
                    type="button"
                    onClick={() =>
                        props.setStore((prev) => ({
                            ...prev,
                            step: 2,
                        }))
                    }
                >
                    Back
                </button>
                <button
                    className="btn simple primary"
                    type="submit"
                    disabled={
                        props.store.mappedData.length === 0 ||
                        errorData.length > 0
                    }
                    onClick={() => {
                        // Handle the submission of the mapped data
                        try {
                            DeclarationsService.createDeclarations(
                                props.store.pid,
                                props.store.uuid,
                                // @ts-ignore
                                correctData
                            ).then((response) => {
                                if (props.store.selectedMapping === "new") {
                                    advService(
                                        { ...POST_EXCEL_FILE_MAPPING },
                                        {
                                            name: props.store.newMappingName,
                                            text: JSON.stringify({
                                                schemaToDisplayText:
                                                    props.store.selectedMappingMapping,
                                                dateFormatText:
                                                    props.store
                                                        .selectedMappingDateMapping,
                                            }),
                                            module: "Declaration",
                                            entityId: props.store.uuid,
                                            entity: "Client",
                                        }
                                    );
                                }

                                props.setStore((prev) => ({
                                    ...prev,
                                    step: 10,
                                }));
                            });
                        } catch (error) {
                            console.error("Error submitting data:", error);
                        }
                        console.log(
                            "Submitting mapped data:",
                            props.store.mappedData
                        );
                    }}
                >
                    Submit
                </button>
            </div>
        </Box>
    );
};

export default ManageMultipleDeclarationsStep3;
